<template>
  <router-view />
</template>

<script>
export default {
  name: "Informa",
};
</script>
